import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryAnnualTaxInfo } from "./services";
import { USE_MOCK, MOCK_ANNUAL_TAX_INFO } from "./mock";

// TODO: 联调期 mock，看完页面改回真实请求（删掉 mock 分支，恢复 queryAnnualTaxInfo()）
export function annualTaxLoader() {
  return defer({
    coreData: resolveLoaderResult(queryAnnualTaxInfo()),
    // coreData: resolveLoaderResult(
    //   new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve(MOCK_ANNUAL_TAX_INFO);
    //     }, 2000);
    //   }),
    // ),
  });
}
